import { InjectionToken } from '@angular/core';

export interface EbbotConfig {
  botId: string;
  ovh: boolean;
}

export const EBBOT_CONFIG = new InjectionToken<EbbotConfig>('ebbot-config');
